import React from "react";
import PropTypes from "prop-types";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from 'reactstrap';
import ReactTable from 'react-table';
import {Link} from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Edit from '@material-ui/icons/Edit'
import AddBox from '@material-ui/icons/AddBox'

export default class DispatchCustomers extends Framework.Components.Collection {
	static propTypes = {
		...Framework.Components.Collection.propTypes,
		loadCustomer: PropTypes.func.isRequired,
	};

	constructor(props) {
		let model = new API.BuildClass(Types.Customers._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.originalSearch = null;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (prevProps.searching !== this.props.searching && this.props.searching !== this.state.search) {
			this.setState({search: this.props.searching})
		}
		if(prevState.data !== this.state.data) {
			let limit = this.state.data.length < 5 ? this.state.data.length : 5;
			this.setState({limit})
		}
		if (prevState.search !== this.state.search) {
			if (typeof(this.props.updateSearch) === 'function') {
				this.props.updateSearch(this.state.search)
			}
		}
	}

	//These functions below are overriding the base collection functions so that we can better use the autosuggestion and searching functionality

	handleCustomerLoad = (e) => {
		let {data} = this.state;
		let pkey = parseInt(e.currentTarget.id);
		let customer = data.find((item) => item.pkey === pkey);
		this.props.loadCustomer(customer, customer.customers_locationss[0], customer.customers_locationss[0].regions.pkey);

	}

	fetchData = async (state) => {
		this.state.limit = 5;
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "ID",
				id: "pkey",
				width: 100,
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.pkey)
			},
			{
				Header: "Name",
				id: "name",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.name),
				Cell: (props) => {
					return (
						<span>
							<Link to={`/customers/${props.original.pkey}`}>
								{props.original.name}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Address",
				id: "customers_locations.street_1",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customers_locationss && obj.customers_locationss.length > 0 && obj.customers_locationss[0].street_1) ? obj.customers_locationss[0].street_1 + ' ' + obj.customers_locationss[0].city + ', ' + obj.customers_locationss[0].state + ' ' + obj.customers_locationss[0].zip : ''
			},
			{
				Header: "Phone",
				accessor: "phone",
			},
			{
				Header: "Alt Number",
				accessor: "phone_alt",
			},
			{
				Header: "Email",
				accessor: "email",
			},
			{
				Header: "Referred",
				accessor: "referer",
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				/** @param {Customers_Object} props.original */
				Cell: props => {
					return (
						<Button
							id={props.original.pkey}
							color="green-meadow"
							size={"sm"}
							block={true}
							onClick={this.handleCustomerLoad}>
							<AddBox fontSize={'small'}/>
						</Button>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: (props) => {
					return (
						<span>
							<Link to={`/customers/${props.original.pkey}`}>
								<Button color="green-meadow" size="sm" block={true}>
									<Edit fontSize={'small'}/>
								</Button>
							</Link>
						</span>
					);
				}
			},
		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Customers')}
							{this.renderHeaderRight("Customers", columns)}
						</div>
					</div>

					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={this.state.search === "" ? [] : data}
						pages={this.state.search === "" ? 0 : pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={this.state.search === "" ? 0 : limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={this.state.search === "" ? 0 : limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}

